import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent} from "@pages/base.component";
import {TaskSidebarItem} from "@shared/ag-task/ag-task.component.ds";
import {MsExcelSurveyInvitees} from "@data/interefaces/panel.interfaces";
import {ActivatedRoute} from "@angular/router";

import {FeatureComponentMode} from "@core/enums/core.enums";

@Component({
  selector: 'app-ms-excel-survey-invitees-task',
  templateUrl: './ms-excel-survey-invitees-task.component.html',
  styleUrls: ['./ms-excel-survey-invitees-task.component.scss']
})
export class MsExcelSurveyInviteesTaskComponent extends BaseComponent implements AfterViewInit {
  featureComponentSidebarEl: TaskSidebarItem[] = [
    {
      title: "Add Row",
      icon: "fa-plus",
      selected: false,
      urlSupport: true,
      disabled: true,
      mode: FeatureComponentMode.ADD_ROW
    },
    {
      title: "Edit Row",
      icon: "fa-pen-to-square",
      selected: false,
      urlSupport: true,
      disabled: true,
      mode: FeatureComponentMode.EDIT_ROW
    },
    {
      title: "Bulk Request Survey Files",
      icon: "fa-files",
      selected: false,
      urlSupport: false,
      disabled: true,
      mode: FeatureComponentMode.BULK_REQUEST_FILES
    },
    {
      title: "Upload",
      icon: "fa-upload",
      selected: false,
      urlSupport: true,
      disabled: false,
      mode: FeatureComponentMode.UPLOAD
    }
  ];
  @Input() selectedFeatureMode: FeatureComponentMode | undefined;
  @Input() selectedRows!: MsExcelSurveyInvitees[];
  @Input() preSelectedFeatureMode!: FeatureComponentMode;
  @Output() goBackEvent: EventEmitter<any> = new EventEmitter<any>();
  isUrlMode: boolean = false;
  urlModeGoBackUrl: string = "/forms/survey-respondents/ms-excel-survey-invitees";
  protected readonly FeatureComponentMode = FeatureComponentMode;

  constructor(protected _activatedRoute: ActivatedRoute) {
    super();
    let paramMode = this._activatedRoute.snapshot.params['mode'];
    if (paramMode) {
      this.isUrlMode = true;
      this.selectedFeatureMode = paramMode;
    }
  }

  ngAfterViewInit(): void {
  }
}
